export default {
      id: "financial-goals-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#financial-goals",
      toString: function () {
        return this.url;
      }
    }